import React, { useEffect, useState, useRef } from "react";
import { SearchOutlined } from "@ant-design/icons";
import Highlighter from "react-highlight-words";
import { BASE_URL,BASE_IMAGE_URL } from "../../service/apiConfig";
import {
  Select,
  Checkbox,
  Typography,
  Space,
  Button,
  Table,
  Modal,
  Form,
  Input,
  notification,
  Upload,
  message,
  Card,
  DatePicker,
  Row,
  Col,
  Radio,
} from "antd";
import moment from "moment";
import 'moment-lunar';

import { LoadingOutlined, PlusOutlined } from "@ant-design/icons";
import countriesApi from "../../service/countriesApi";
import locationTourApi from "../../service/locationTourService";
import translateApi from "../../service/translateService";
// import eventServiceApi from "../../service/locationserviceService";
import eventServiceApi from "../../service/eventService";
import eventCategoryApi from "../../service/eventCategoriesService";
import {
  EditorState,
  convertToRaw,
  ContentState,
  convertFromHTML,
} from "draft-js";
// import { useHistory } from "react-router-dom";
import { useParams } from "react-router-dom";
import "./management.css";
import draftToHtml from "draftjs-to-html";
import MapManagement from "./MapManagement";
import { useSelector } from "react-redux";
import isEqual from 'lodash/isEqual';
import get from 'lodash/get';
import adminService from "../../service/adminService";

// import htmlToDraft from "html-to-draftjs";

const { Option } = Select;
export default function ManagementPage() {

  const deepEqual = isEqual;
  const [eventId, setEventId] = useState(0);
  const currentLocation = useSelector((state) => state.currentLocation);
  
  const [centerMap, setCenterMap] = useState({
    lat: "",
    lng: "",
  });

  const [isShowUpdateService, setIsShowUpdateService] = useState(false);

  const [listLocationService, setListLocationService] = useState([]);

  const [listCountry, setListCountry] = useState([]);
  const [province, setProvince] = useState([]);
  const [listEventCategory, setListServiceCategory] = useState([]);

  const [fileListService, setFileListService] = useState([]);
  const [fileListEventSubmit, setFileListEventSubmit] = useState([]);

  const [loading, setLoading] = useState(false);
  const [invalidImage, setInvalidImage] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [imagePath, setImagePath] = useState("");
  const [eventData, setEventData] = useState();
  const [language, setLanguage] = useState("vi");
  const [loadingTranslate, setLoadingTranslate] = useState(false);
  const [titleData, setTitleData] = useState("");
  const [desData, setDesData] = useState("");
  const [dataTranslate, setDataTranslate] = useState();

  const { id } = useParams();
  const [form] = Form.useForm();
  const [formEvent] = Form.useForm();
  const [instroductionContent, setInstroductionContent] = useState("");
  
  const [dataChange, setDataChange] = useState(true);
  const [lastData, setLastData] = useState({});
  const [isShowLunar, setShowLunar] = useState(false);
  const [onRegisterAds, setOnRegisterAds] = useState(false);
  const [isShowAds,  setIsShowAds] = useState(false);
  const [isCustomer,  setIsCustomerAds] = useState(false);
  const [sendNotification, setSendNotification] = useState(false);

  const [dataUpdateCalendarLunar, setDataUpdateCalendarLunar] = useState([]);

 const [filterOnChange, setFilterOnChange] = useState(false);
 const [adsFilterOnChange, setAdsFilterOnChange] = useState(false);
 const [allChecked, setAllChecked] = useState(false);
 const [selectedRowKeys, setSelectedRowKeys] = useState([]);

 const [updateCalendarLunar, setUpdateCalendarLunar] = useState(false);

  const validateLunar = 
  [
      // { 
      //   required: true,
      //   message: 'Phải nhập ngày âm lịch',
      // },
      {
        message: 'Ngày âm lịch phải đúng định dạng',
        pattern: new RegExp("^([0-2][0-9]|(3)[0-0])(/)(((0)[0-9])|((1)[0-2]))(/)((20)[2-9][0-9])"),
    }
  ]


  const [editorStateInstroduction, setEditorStateInstroduction] = useState(
    () => {
      const blocksFromHTML = convertFromHTML(instroductionContent);
      const contentState = ContentState.createFromBlockArray(
        blocksFromHTML.contentBlocks,
        blocksFromHTML.entityMap
      );
      return EditorState.createWithContent(contentState);
    }
  );

  useEffect(() => {
    getAllEvent();
  }, [adsFilterOnChange]);

  useEffect(() => {
    if(!filterOnChange){
      getAllEvent();
    }else{
      getEventCalendarByCategory()
    }    
  }, [filterOnChange]);

  

  //update calendarlunar
  useEffect(() => {
    if(updateCalendarLunar){
      updateCalendarLunarToSolar() 
      setUpdateCalendarLunar(false)
    }
  }, [updateCalendarLunar]);

  const onChangeFilter = (e) => {
    setAllChecked(false)
    setSelectedRowKeys([])
    setFilterOnChange(!filterOnChange);    
   }

   const onChangeAdsFilter = (e) => {    
    setAdsFilterOnChange(!adsFilterOnChange);    
   }   
  

  const onEditorStateChangeInstroduction = (editorState) => {
    setEditorStateInstroduction(editorState);
  };
  const onFormValueChange = () =>{
    setDataChange(true)
  }
  const onLocationChange = (location) => {
    setDataChange(true)
    formEvent.setFieldsValue({
      latitude:location.lat,
      longitude:location.lng,
    });
  }

  const getAllEvent = () => {
    if(adsFilterOnChange) {
      eventServiceApi.getAll({'ads': true}).then((res) => {
        setListLocationService(res.data);
        setDataUpdateCalendarLunar([])
      });
    }else{
      eventServiceApi.getAll().then((res) => {
        setListLocationService(res.data);
        setDataUpdateCalendarLunar([])
      });
    }
    
  };

  const getEventCalendarByCategory = () => {
    eventServiceApi.getEventCalendarLunarByCateId().then((response) => {
      setListLocationService(response.data)
      setDataUpdateCalendarLunar(response.data)
      setSelectedRowKeys([])
    });
  };  

  const deleteEvent = () => {
    eventServiceApi.deleteEventById(eventId).then((res) => {
      notification.success({ message: `Xóa Thành Công` });
      getAllEvent();
      setOpenDeleteDialog(false);
    });
  };

  const updateCalendarLunarToSolar = async () => {
    const result = await Promise.all(selectedRowKeys.map(item => {
      return eventServiceApi.updateCalendarLunarEvent(item.id)
    }))
    console.log(`updateCalendarLunarToSolar result =${JSON.stringify(result)}`)
    
    if(result?.[0].data != null ){
      notification.success({ message: `Cập nhật sự kiện ngày âm lịch sang ngày dương lịch thành công.`});    
    }else{
      notification.error({ message: `Có lỗi trong quá trình cập nhật dữ liệu.`});    
    }        
    getEventCalendarByCategory();            
  }

  const onChangeTitle = (value) => {
    setTitleData(value.target.value);
  };
  const onChangeDes = (value) => {
    setDesData(value.target.value);
  };
  const openModalService = (id) => {
    setEventId(id);
    getCountry();
    getEventCategories();
    setShowLunar(false)
    if (id) {
      eventServiceApi.getById(id,language).then((res) => {
        console.log(res);
        const pictureFilenameParse =
          res.data.pictureFilename != null && res.data.pictureFilename != ""
            ? JSON.parse(res.data.pictureFilename)
            : [];
        const files = [];
        const filesSubmit = [];
        if (pictureFilenameParse.length > 0) {
          pictureFilenameParse.forEach((item) => {
            files.push({ url: BASE_IMAGE_URL + item });
            filesSubmit.push(item);
          });
        }
        onSelectCountry(res.data.countryId)
        setFileListService(files);
        setFileListEventSubmit(filesSubmit);
        setEventData(res.data);
        setDesData(res.data.description);
        setTitleData(res.data.title);
        console.log(111, res.data.longitude);
        setCenterMap({
          lng: res.data.longitude,
          lat: res.data.latitude,
        });
        setShowLunar(res.data?.isLunar)
        setOnRegisterAds(res.data.isShowAds  ?? false)
        setIsShowAds(res.data.isShowAds  ?? false)
        setIsCustomerAds(res.data.isCustomer ?? false)
        formEvent.setFieldsValue({
          title: res.data.title,
          countryId: res.data.countryId,
          eventCategoryId: res.data.eventCategoryId,
          provinceId: res.data.provinceId,
          address: res.data.address,
          longitude: res.data.longitude,
          latitude: res.data.latitude,
          description: res.data.description,
          website: res.data.website,
          isLunar: res.data?.isLunar,
          dateTimeOpenLunar: res.data?.dateTimeOpenLunar,
          dateTimeCloseLunar: res.data?.dateTimeCloseLunar,          
          dateTimeClose:
            res.data.dateTimeClose != null
              ? moment(res.data.dateTimeClose)
              : null,
          dateTimeOpen:
            res.data.dateTimeOpen != null
              ? moment(res.data.dateTimeOpen)
              : null,

          isAdsTripZe: res.data.isCustomer == true ?  false : res.data.isShowAds,
          isShowAds: res.data.isShowAds,
          isCustomer: res.data.isCustomer,              
        });
        setIsShowUpdateService(true);
      });
    }
  };

  const onCloseModalEvent = () => {
    setIsShowUpdateService(false);
    setFileListService([]);
    setLanguage("vi");
    setFileListEventSubmit([]);
    setShowLunar(false)
    setOnRegisterAds(false)
    setEventId(0)
    setCenterMap('')
    formEvent.setFieldsValue({
      title: "",
      countryId: null,
      eventCategoryId: null,
      address: "",
      longitude: "",
      latitude: "",
      description: "",
      eventCategory: "",
      dateTimeOpenLunar: "",
      dateTimeCloseLunar: "",
      dateTimeOpen: "",
      dateTimeClose: "",
      date: "",
      isLunar: false,
      isAdsTripZe: false,
      isShowAds: false,
      isCustomer: false,
      sendNotification: false,
    });
    setEventData(null);
    setIsCustomerAds(false)
    setIsShowAds(false)
  };

  const getCountry = () => {
    countriesApi.getAll().then((response) => {
      setListCountry(response.data);
      formEvent.setFieldsValue({ countryId: response.data[0].id });
      onSelectCountry(response.data[0]?.id)
    });
  };


  const onSelectCountry = async (value) => {
    await countriesApi.getById(value).then((res) => {
      setProvince(res.data.province);
      form.setFieldsValue({
        provinceId: "",
      });
    });
  };

  const onSelectProvince = async (key) => {
    province.forEach((element) => {
      if ((element.id === key)) {
        setCenterMap({
          lng: element.longitude,
          lat: element.latitude,
        });
      }
    });
  };

  const getEventCategories = () => {
    eventCategoryApi.getAll().then((response) => {
      setListServiceCategory(response.data);
    });
  };

  const layout = {
    labelCol: { span: 5 },
    wrapperCol: { span: 20 },
  };

  const openDeleteService = (id) => {
    setEventId(id);
    setOpenDeleteDialog(true);
  };
  const [searchText, setSearchText] = useState("");
  const [searchedColumn, setSearchedColumn] = useState("");
  const searchInput = useRef(null);

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText("");
  };
  
  const selectAll = (e) => {
    const checked = e.target.checked;
    setSelectedRowKeys(checked ? dataUpdateCalendarLunar : [])
    setAllChecked(checked)    
  }

  const onChangeCkeckbox = (e, rec) => {
    const checked = e.target.checked;    
    if (checked) {
      setSelectedRowKeys([...selectedRowKeys, rec])       
    } else {
      setAllChecked(checked)
      setSelectedRowKeys(selectedRowKeys.filter((item) => item.id !== rec.id))      
    }
  }

  const getColumnSearchProps = (dataIndex, placeHolderSearch) => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters,
    }) => (
      <div
        style={{
          padding: 8,
        }}
      >
        <Input
          ref={searchInput}
          placeholder={`Tìm kiếm ${placeHolderSearch}`}
          value={selectedKeys[0]}
          onChange={(e) =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: "block",
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            Tìm kiếm
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            Đặt lại
          </Button>
          <Button
            type="link"
            size="small"
            onClick={() => {
              confirm({
                closeDropdown: false,
              });
              setSearchText(selectedKeys[0]);
              setSearchedColumn(dataIndex);
            }}
          >
            Lọc
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? "#1890ff" : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
    get(record, dataIndex)
    .toString()
    .toLowerCase()
    .includes(value.toLowerCase()),
      // record[dataIndex]?.toString().toLowerCase().includes(value.toLowerCase()),
      
    onFilterDropdownVisibleChange: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      // searchedColumn === dataIndex ? (
        isEqual(searchedColumn, dataIndex) ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: "#ffc069",
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text?.toString() : ""}
        />
      ) : (
        text
      ),
  });
  const columnsServiceCalendalunar = [
    {
      title: () => {
       return (
         dataUpdateCalendarLunar?.length > 0 ? <Checkbox  visible={false}
           checked={allChecked}
           onChange={(e) => selectAll(e)}
         ></Checkbox> : <div></div>
       );
     } ,
     columnWidth: '5px',
     dataIndex: "checked",
     key: "id",
     render: (value, rec, index ) =>        
       dataUpdateCalendarLunar?.length > 0 && <Checkbox
         checked={(allChecked || selectedRowKeys.includes(rec))}
         onChange={(e) => onChangeCkeckbox(e, rec)}
       ></Checkbox>,
   },   
  ]

  
  const columnsServiceCheckBox = [
    {
       title: () => {
        return (
          <Checkbox  visible={false}
            checked={allChecked}
            onChange={(e) => selectAll(e)}
          ></Checkbox>
        );
      } ,
      columnWidth: '5px',
      dataIndex: "checked",
      key: "id",
      render: (value, rec, index ) =>        
        <Checkbox
          checked={(allChecked || selectedRowKeys.includes(rec))}
          onChange={(e) => onChangeCkeckbox(e, rec)}
        ></Checkbox>,
    },
    
  ]

  const columnServiceRequired = [
    {
      title: "Tiêu đề",
      dataIndex: "title",
      key: "title",
      ...getColumnSearchProps("title", "tiêu đề"),
    },
    {
      title: "Địa chỉ",
      dataIndex: "address",
      key: "address",
      ...getColumnSearchProps("address", "địa chỉ"),
    },
    {
      title: "Bắt đầu(âm lịch)",
      dataIndex: "dateTimeOpenLunar",
      key: "dateTimeOpenLunar",
      ...getColumnSearchProps("dateTimeOpenLunar", "ngày bắt đầu âm lịch"),
    },
    {
      title: "Kết thúc(âm lịch)",
      dataIndex: "dateTimeCloseLunar",
      key: "dateTimeCloseLunar",
      ...getColumnSearchProps("dateTimeCloseLunar", "ngày kết thúc âm lịch"),
    },
    {
      title: "Bắt đầu",
      dataIndex: "dateTimeOpen",
      key: "dateTimeOpen",
      render: (value) =>
        value != null &&
        value != "" && <div>{moment(value).format("DD-MM-YYYY HH:mm:ss")}</div>,
    },
    {
      title: "Kết thúc",
      dataIndex: "dateTimeClose",
      key: "dateTimeClose",
      render: (value) =>
        value != null &&
        value != "" && <div>{moment(value).format("DD-MM-YYYY HH:mm:ss")}</div>,
    },
    {
      title: "Loại sự kiện",
      dataIndex: ["eventCategoryEvent", "name"],
      key: "name",
      ...getColumnSearchProps(["eventCategoryEvent", "name"], "loại sự kiện"),
    },    
    {
      title: "Action",
      key: "action",
      render: (_, record) => (
        dataUpdateCalendarLunar?.length == 0 && <Space size="middle">
           <Button
            type="primary"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openModalService(_.id)}
          >
            Sửa
          </Button>
          <Button
            type="danger"
            style={{
              borderRadius: 8,
            }}
            onClick={() => openDeleteService(_.id)}
          >
            Xóa
          </Button>          
        </Space>
      ),
    },    
  ]
  const columnsService = dataUpdateCalendarLunar?.length > 0 ? columnsServiceCheckBox.concat(columnServiceRequired) : columnServiceRequired

  const onHandleTranslate = (id, forceLang) => {
    setLoadingTranslate(true);
    const textData = {
      title: titleData,
      description: desData,
    };
    const data = {
      text: textData,
      language: forceLang ? forceLang : language,
      type: "event",
      id: id,
    };
    translateApi.translate(data).then((res) => {
      const textTranslate = res.data;
      console.log("textTranslate", textTranslate);
      if (textTranslate.length > 0) {
        setLoadingTranslate(false);
        const newdata = [];
        textTranslate.map((e) => {
          if (e.language == language) {
            formEvent.setFieldsValue({
              title: e.title,
              description: e.description,
            });
          }
        });
        console.log("newdata", newdata);
      } else {
        setLoadingTranslate(false);
        setDataTranslate(dataTranslate);
        let newFormData = {
          title: res.data.title,
          description: res.data.description,
        }
        setDataChange(false)
        if (!deepEqual(newFormData, lastData[data.language])){
          setDataChange(true)
        }
        formEvent.setFieldsValue({
          title: res.data.title,
          description: res.data.description,
        });
      }
    });
  };

  const onFinishHandleEvent = (values) => {
    values.pictureFilename = fileListEventSubmit;
    console.log(values);
    values.isShowAds = values.isAdsTripZe == true ? true : values.isShowAds
    values.isCustomer = isCustomer
    values.userId = adminService.AuthService.getCurrentUser().id
    const stringData = JSON.stringify(values);
    if (eventId !== 0) {
      if (language === "vi") {
        eventServiceApi.updateEvent(eventId, values).then((res) => {
          notification.success({ message: "Tạo sự Kiện Thành Công" });
          let newData = {}
          newData[language] = {}
          newData[language].title = formEvent.getFieldValue("title")
          newData[language].description = formEvent.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllEvent();
          onCloseModalEvent();
        });
      } else if (language === "en") {
        const temp = {
          en: {
            title: values.title,
            description: values.description,
          },
        };
        const data = { 
          textTranslate: JSON.stringify(temp),
          userId: adminService.AuthService.getCurrentUser().id
        };
        eventServiceApi.updateEvent(eventId, data).then((res) => {
          notification.success({ message: "Tạo sự Kiện Thành Công" });
          getAllEvent();
          onCloseModalEvent();
        });
      } else {
        var temp={}
        temp[language] =
         {
           title: values.title,
           description: values.description,
         }
        // const temp={
        //   'en':{
        //     title: values.title,
        //     description: values.description,
        //   }
        // }
        const data = { textTranslate: JSON.stringify(temp) };
        eventServiceApi.updateEvent(eventId, data).then((res) => {
          notification.success({ message: "Tạo sự Kiện Thành Công" });
          let newData = {}
          newData[language] = {}
          newData[language].title = formEvent.getFieldValue("title")
          newData[language].description = formEvent.getFieldValue("description")
          setLastData(newData)
          setDataChange(false)
          getAllEvent();
        });
      }
    } else {
      eventServiceApi.createEvent(values).then((res) => {
        notification.success({ message: "Tạo sự Kiện Thành Công" });
        formEvent.setFieldsValue({
          title: "",
          countryId: null,
          eventCategory: "",
          dateTimeOpen: "",
          dateTimeClose: "",
          dateTimeOpenLunar: "",
          dateTimeCloseLunar: "",          
          address: "",
          longitude: "",
          latitude: "",
          description: "",
          website: ""
        });
        getAllEvent();
        onCloseModalEvent();
      });
    }
  };

  const uploadButton = (
    <div>
      {loading ? <LoadingOutlined /> : <PlusOutlined />}
      <div
        style={{
          marginTop: 8,
        }}
      >
        Thêm Ảnh
      </div>
    </div>
  );

  const handleChangeService = async ({ fileList: newFileList }) => {
    if (!invalidImage) {
      onFormValueChange()
      setFileListService(newFileList);
      const urlArray = [];
      const urlArraySubmit = [];
      let checkTotal = 0;
      let check = 0;
      await newFileList.forEach((item) => {
        if (typeof item?.status !== "undefined") {
          checkTotal++;
          if (item.status === "uploading") {
            setLoading(true);
            return;
          }
          if (item.status === "done") {
            check++;
          }
        } else {
          urlArray.push(item);
          urlArraySubmit.push("/images/" + item.url.split("/images/")[1]);
        }
      });
      if (check === checkTotal) {
        newFileList.forEach((item) => {
          if (typeof item?.status !== "undefined") {
            const temp = { url: BASE_IMAGE_URL + item.response.data.url };
            urlArray.push(temp);
            urlArraySubmit.push(item.response.data.url);
          }
        });
      }

      setFileListEventSubmit(urlArraySubmit);
      setLoading(false);
    }
  };

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";

    if (!isJpgOrPng) {
      message.error("You can only upload JPG/PNG file!");
      setInvalidImage(true);
    } else {
      setInvalidImage(false);
    }

    const isLt2M = file.size / 1024 / 1024 < 2;

    return isJpgOrPng;
  };

  // formEvent.setFieldsValue(
  //   {
  //     latitude:
  //       currentLocation?.latitude != ""
  //         ? currentLocation?.latitude
  //         : eventData?.latitude,
  //     longitude:
  //       currentLocation?.longitude != ""
  //         ? currentLocation?.longitude
  //         : eventData?.longitude,
  //   },
  //   []
  // );

  const onSelectLanguage = (value) => {
    onHandleTranslate(eventId, value);
    setLanguage(value);
  };

  const onRegisterAdsChange = () => {
    setOnRegisterAds(!onRegisterAds)
    form.setFieldsValue({isCustomer: false, isAdsTripZe: true})
    setIsShowAds(false)
    setIsCustomerAds(false)
  };

  const onSendNotificationChange = (value) => {
    setSendNotification(!sendNotification)
    form.setFieldsValue({sendNotification: !sendNotification})
  };

  const onChangeShowAds = () => {
    form.setFieldsValue({isCustomer: false})
    setIsShowAds(true)
    setIsCustomerAds(false)
    setDataChange(true)
  }

  const onChangeShowCustomerAds = () => {
    form.setFieldsValue({isAdsTripZe: false})
    setIsCustomerAds(true)
    setIsShowAds(false)
    setDataChange(true)
  }

  const onCheckLunarChange =(e) => {
    setShowLunar(!isShowLunar)
  } 

  const convertLunarToSolar = (date) => {
    const err = false
    let dd = 1
    let mm = 1
    let yyyy = 2022
    let result = null
    try{
       const arr = date != '' ? date.split('/') : ''
        dd = parseInt(arr[0])
        mm = parseInt(arr[1])
        yyyy = parseInt(arr[2])
       if((mm < 1 || mm > 12)
         || (dd < 1 || dd > 30)
         || (arr[2].length != 4)) {
         err = true
       }
    }catch(e){     
    }finally{
      if(!err) {
          result = moment().year(yyyy).month(mm).date(dd).solar()      
        }
    }
    return result
  }

  const validateInputDateOpenLunar = () => {    
    if (isShowLunar ){
      const dateTemp =  formEvent.getFieldValue("dateTimeOpenLunar")           
      const result  = convertLunarToSolar(dateTemp)
       formEvent.setFieldsValue({
         dateTimeOpen: result ?? ''
       })
    }     
  }

  const validateInputDateCloseLunar = () => {    
    if (isShowLunar ){
      const dateTemp =  formEvent.getFieldValue("dateTimeCloseLunar")      
      const result  = convertLunarToSolar(dateTemp)
      formEvent.setFieldsValue({
        dateTimeClose: result ?? ''
      })    
    }
 }

  return (
    <>
      <Card
        title={
          <Typography style={{ textAlign: "center" }}>
            Sự Kiện
          </Typography>
        }
        extra={
          <div>            
            <Checkbox  value={1} onChange={onChangeAdsFilter} >Dữ liệu quảng cáo</Checkbox>
            <Checkbox  value={1} onChange={onChangeFilter} >Sự kiện âm lịch cần được cập nhật</Checkbox>             
          {filterOnChange ? <Button
            type="primary"
            disabled={ selectedRowKeys?.length > 0 ? false : true}
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setUpdateCalendarLunar(true)
            }}
          >
            Cập nhật  
          </Button> 
          : <Button
            type="primary"
            style={{
              borderRadius: "8px",
            }}
            onClick={() => {
              setIsShowUpdateService(true);
              getEventCategories();
              getCountry();
            }}
          >
            Tạo Sự Kiện
          </Button>
        }
          </div>
        }
      >
        <Table
          columns={columnsService}
          dataSource={listLocationService}
          bordered
        />

        <Modal
          title={
            eventId !== 0
              ? "Cập Nhật Kiện Thành Công"
              : "Tạo sự Kiện Thành Công"
          }
          visible={isShowUpdateService}
          // onOk={handleOkTour}
          width="70%"
          onCancel={() => {
            setEventId(0);
            onCloseModalEvent();
            setFileListEventSubmit([]);
            setLanguage("vi");
          }}
          footer={[
            <>
              <Button
                size="small"
                onClick={() => {
                  onCloseModalEvent();
                }}
              >
                Đóng
              </Button>
              <Button
                size="small"
                className="btn btn-primary"
                type="primary"
                form="CU-tour"
                key="submit"
                htmlType="submit"
                disabled = {!dataChange}
              >
                Hoàn Thành
              </Button>
            </>,
          ]}
        >
          <Row justify="space-around">
            <Col span={12}>
            {eventId!=0&&<Row justify="end">
                <Select
                  onChange={onSelectLanguage}
                  defaultValue="vi"
                  value={language}
                >
                  <Option value="vi">Tiếng Việt</Option>
                  <Option value="en">English</Option>
                  <Option value="fr">French</Option>
                  <Option value="zh-CN">Chinese</Option>
                  <Option value="ko">Korean</Option>
                  <Option value="de">German</Option>
                </Select>
                <Button
                  type="primary"
                  onClick={() => {
                    onHandleTranslate(eventId);
                  }}
                  loading={loadingTranslate}
                >
                  Dịch
                </Button>
              </Row>}
              <Upload
                name="file"
                listType="picture-card"
                className="avatar-uploader"
                showUploadList={true}
                multiple={true}
                action={BASE_IMAGE_URL + "/api/upload"}
                beforeUpload={beforeUpload}
                onChange={handleChangeService}
                fileList={fileListService}
                disabled={ language!='vi' }
              >
                {uploadButton}
              </Upload>
              <Form
                {...layout}
                form={formEvent}
                name="CU-tour"
                onFinish={onFinishHandleEvent}
                onValuesChange = {onFormValueChange}
              >              
                <Form.Item
                  name="title"
                  label="Sự Kiện"
                  rules={[{ required: true }]}
                >
                  <Input size="large" onChange={onChangeTitle} />
                </Form.Item>
                <Form.Item name="countryId" label="Quốc Gia">
                  <Select onChange={onSelectCountry} disabled={ language!='vi' }> {/*onChange={onSelectCountry}*/}
                    {listCountry?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.countryName}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="provinceId" label="Tỉnh Thành">
                  <Select onChange={onSelectProvince} disabled={ language!='vi' }> 
                    {province?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>                
                <Form.Item
                  name="eventCategoryId"
                  label="Loại sự kiện"
                  rules={[{ required: true }]}
                >
                  <Select  disabled={ language!='vi' }>
                    {listEventCategory?.map((x) => (
                      <Option value={x.id} key={x.id}>
                        {x.name}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
                <Form.Item name="isLunar" label="Chọn ngày âm lịch" valuePropName="checked" >
                    <Checkbox onChange={onCheckLunarChange} disabled={ language!='vi' }/>
                </Form.Item>
                {
                  isShowLunar ? 
                <div>
                  <Form.Item name="dateTimeOpenLunar" label="Ngày bắt đầu" 
                  validateTrigger="onBlur"                  
                  rules={validateLunar}>
                    <Input size="large" placeholder="dd/MM/yyyy" disabled={ language!='vi' }                    
                    onBlur={validateInputDateOpenLunar}/>
                  </Form.Item>
                  <Form.Item name="dateTimeCloseLunar" label="Ngày kết thúc" 
                  validateTrigger="onBlur"
                  rules={validateLunar}>
                      <Input placeholder="dd/MM/yyyy" size="large" disabled={ language!='vi' }
                      onBlur={validateInputDateCloseLunar}/>
                  </Form.Item></div> : null
                }
                 {
                  !isShowLunar ? 
                <div><Form.Item name="dateTimeOpen" label="Bắt đầu lúc">
                  <DatePicker
                    placeholder="Chọn ngày"
                    format="DD/MM/YYYY HH:mm"
                    disabled={ language!='vi' }
                    showTime={{ defaultValue: moment("00:00:00", "DD/MM/YYYY HH:mm") }}
                  />
                </Form.Item>
                <Form.Item name="dateTimeClose" label="Kết thúc lúc" >
                  <DatePicker disabled={ language!='vi' }            
                    placeholder="Chọn ngày"       
                    format="DD/MM/YYYY HH:mm"
                    showTime={{ defaultValue: moment("00:00:00", "DD/MM/YYYY HH:mm") }}
                  />
                </Form.Item>
                </div> : null
                }
                <Form.Item name="address" label="Địa Chỉ" >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item
                  name="latitude"
                  label="Latitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large"  disabled={ language!='vi' }/>
                </Form.Item>
                <Form.Item
                  name="longitude"
                  label="Longitude"
                  rules={[{ required: true }]}
                >
                  <Input size="large" disabled={ language!='vi' } />
                </Form.Item>
                <Form.Item name="website" label="Website" >
                  <Input size="large" disabled={ language!='vi' }/>
                </Form.Item>
                               
                <Form.Item name="description" label="Mô Tả">
                  <Input.TextArea rows={10} onChange={onChangeDes} />
                </Form.Item>
                <Form.Item label="Quảng cáo" name="isShowAds" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onRegisterAdsChange}/>                                                  
                 </Form.Item>

                {onRegisterAds ?<Form.Item label="TripZe" name="isAdsTripZe" valuePropName="checked">
                    <Radio value={'isAdsTripZe'} disabled={ language!='vi' } onChange={onChangeShowAds}/>                                                  
                 </Form.Item> : null}

                 {onRegisterAds ? <Form.Item label="Đối tác" name="isCustomer" valuePropName="checked">
                    <Radio value={'isCustomer'} disabled={ language!='vi' } onChange={onChangeShowCustomerAds}/>                                                  
                 </Form.Item> : null }

                 <Form.Item label="Gửi thông báo" name="sendNotification" valuePropName="checked">
                    <Checkbox  disabled={ language!='vi' } onChange={onSendNotificationChange}/>                                                  
                 </Form.Item>                                      
              </Form>
            </Col>
            <Col span={10}>
              <MapManagement location={centerMap} onChange = {onLocationChange} />
            </Col>
          </Row>
        </Modal>
      </Card>
      <Modal
        visible={openDeleteDialog}
        onOk={deleteEvent}
        onCancel={() => {
          setEventId(0);
          setOpenDeleteDialog(false);
        }}
        title={`Xóa sự kiện`}
      >
        Bạn có chắc muốn xóa sự kiện này?
      </Modal>
    </>
  );
}
